import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installReportAccessFetch } from './system/report-access';
installReportAccessFetch();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);